import React, {useCallback, useContext, useEffect} from 'react';
import BodyContentView from '../../views/bodyContentView';
import useKeyPress from '../../../hooks/useKeyPress';
import CommandsContext from '../../../context/commandsContext';
import Info from '.';
import {useMenu} from '../../../hooks/useMenu';

function SensorError({onExit}) {
  const leftPress = useKeyPress('ArrowLeft');
  const {onUpdateCommands} = useContext(CommandsContext);
  const {onComponent} = useMenu();

  useEffect(() => {
    if (!leftPress) return;

    onLeft();
  }, [leftPress]);

  const onLeft = useCallback(() => {
    onComponent(<Info />);
  }, []);

  useEffect(() => {
    onUpdateCommands({onLeft});
  }, [onLeft]);

  return (
    <BodyContentView
      title="[003] Sensor Error"
      left="Back"
      right=""
      caption={
        <>
          <span>The sensor is not responding.</span>
          <p>1. Check for two-phase flow.</p>
          <p>2. Verify wiring between the transmitter and the sensor.</p>
          <p>3. Check the test points and sensor coils.</p>
          <p>4. Purge the sensor tubes.</p>
        </>
      }
    />
  );
}

export default SensorError;
